(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2465],{

/***/ 30588:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace",
      function () {
        return __webpack_require__(42529);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputCheckbox = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error, visited = _meta.visited;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "flex ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                        type: "checkbox",
                        required: props.required,
                        disabled: props.disabled,
                        className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ".concat(props.required ? "is-required" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                            focusable: "false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "3",
                                d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "block Form-label label ".concat(props.spanClassName, " ").concat(props.required ? "is-required" : ""),
                        children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: props.label
                            }
                        }) : props.label
                    })
                ]
            }),
            props.required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: visited && error ? "" : "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-red-brand text-sm",
                    children: error
                })
            })
        ]
    }));
};
InputCheckbox.defaultProps = {
    required: undefined,
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputCheckbox);


/***/ }),

/***/ 4792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Textarea = function(props) {
    var input = props.input, children = props.children, rows = props.rows, _meta = props.meta, touched = _meta.touched, error = _meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-between items-center",
                children: props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    htmlFor: props.id,
                    className: "Form-label ".concat(props.required ? "is-required" : "", " ").concat(props.disabled ? "disabled" : "", " ").concat(props.labelClass),
                    children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: props.label
                        },
                        className: "inline-block"
                    }) : props.label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", _objectSpread({}, input, {
                required: props.required,
                disabled: props.disabled,
                placeholder: props.placeholder,
                autoCorrect: props.autoCorrect,
                rows: rows,
                className: props.className ? "".concat(props.className, " ").concat(touched && error ? "error" : "") : "w-full text-black ".concat(props.inputClassName, " ").concat(touched && error ? "error" : ""),
                children: children
            })),
            touched && error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-red-brand text-sm",
                children: error
            })
        ]
    }));
};
Textarea.defaultProps = {
    id: undefined,
    label: undefined,
    required: undefined,
    disabled: undefined,
    placeholder: undefined,
    rows: undefined,
    autoCorrect: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var withRouterPageLayout = function(ComposedComponent) {
    var WithRouteWrapper = /*#__PURE__*/ function(Component1) {
        "use strict";
        _inherits(WithRouteWrapper, Component1);
        var _super = _createSuper(WithRouteWrapper);
        function WithRouteWrapper() {
            _classCallCheck(this, WithRouteWrapper);
            return _super.apply(this, arguments);
        }
        _createClass(WithRouteWrapper, [
            {
                key: "render",
                value: function render() {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ComposedComponent, _objectSpread({
                        router: this.context.router
                    }, this.props)));
                }
            }
        ]);
        return WithRouteWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.Component);
    _defineProperty(WithRouteWrapper, "contextTypes", {
        router: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
    });
    WithRouteWrapper.getInitialProps = ComposedComponent.getInitialProps;
    // Hoists non standard static properties
    WithRouteWrapper.pageLayout = ComposedComponent.pageLayout;
    WithRouteWrapper.layoutProps = ComposedComponent.layoutProps;
    WithRouteWrapper.pageName = ComposedComponent.pageName;
    return WithRouteWrapper;
};
/* harmony default export */ __webpack_exports__["Z"] = (withRouterPageLayout);


/***/ }),

/***/ 42529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ marketplace; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/withRouterPageLayout.js
var withRouterPageLayout = __webpack_require__(61167);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/react-final-form-listeners/dist/react-final-form-listeners.es.js
var react_final_form_listeners_es = __webpack_require__(73337);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Form/Checkbox.js
var Checkbox = __webpack_require__(71662);
// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
// EXTERNAL MODULE: ./components/Form/Select.js
var Select = __webpack_require__(66569);
;// CONCATENATED MODULE: ./components/Form/CheckboxList.js



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var MultipleSelect = function(param1) {
    var title = param1.title, required = param1.required, items = param1.items, name1 = param1.name, validate = param1.validate;
    var ref = (0,react.useState)([]), checked = ref[0], setChecked = ref[1];
    var ref1 = (0,react.useState)(false), bypass = ref1[0], setBypass = ref1[1];
    var handleOnChange = function(name, input) {
        var parsed = checked.includes(name) ? checked.filter(function(element) {
            return element !== name;
        }) : _toConsumableArray(checked).concat([
            name
        ]);
        setChecked(parsed);
        input.onChange(parsed.join(","));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-start justify-start",
        onClick: function() {
            return setBypass(true);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "Form-label ".concat(required && "is-required"),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rounded-tr-lg rounded-bl-lg border pl-5 pr-2 py-6 mt-1 flex flex-col space-y-3 overflow-y-scroll max-h-[200px] w-full ".concat(!checked.length && bypass ? "border-red-brand" : "border-[#c7c7c7]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: name1,
                    type: "text",
                    required: required,
                    validate: validate,
                    children: function(param2) {
                        var input = param2.input;
                        return items.map(function(param, key) {
                            var label = param.label, name = param.name;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCheckbox, {
                                    className: "text-sm",
                                    label: label,
                                    onChange: function() {
                                        return handleOnChange(name, input);
                                    }
                                })
                            }, key);
                        });
                    }
                })
            }),
            !checked.length && bypass && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-red-brand text-sm mt-1",
                children: "Trebuie selectata minim o optiune"
            })
        ]
    }));
};
var InputCheckbox = function(param) {
    var className = param.className, label = param.label, onChange = param.onChange;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            className: "Form-checkbox flex ".concat(className ? className : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "checkbox",
                    className: "checkbox-input opacity-0 w-0 h-0",
                    onChange: onChange
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white cursor-pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true",
                        focusable: "false",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "3",
                            d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "inline-block label cursor-pointer",
                    children: typeof label === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: label
                        }
                    }) : label
                })
            ]
        })
    });
};
/* harmony default export */ var CheckboxList = (MultipleSelect);

// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./lib/validations.js + 1 modules
var validations = __webpack_require__(38294);
;// CONCATENATED MODULE: ./components/Marketplace/SubscribeForm.js












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var countries = [
    "",
    "Austria",
    "Belgium",
    "Bulgaria",
    "Croatia",
    "Republic of Cyprus",
    "Czech Republic",
    "Denmark",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Hungary",
    "Ireland",
    "Italy",
    "Latvia",
    "Lithuania",
    "Luxembourg",
    "Malta",
    "Netherlands",
    "Poland",
    "Portugal",
    "Romania",
    "Slovakia",
    "Slovenia",
    "Spain",
    "Sweden", 
];
var categories = [
    {
        label: "Racire, Purificare, Incalzire",
        name: "aer-conditionat-climatizare"
    },
    {
        label: "Curatenie, Intretinere casa",
        name: "curatenie-intretinere-casa"
    },
    {
        label: "Bauturi, Cafea, Petshop",
        name: "apa-espresso-cafea-suc"
    },
    {
        label: "Cosmetice",
        name: "cosmetice-ingrijire-personala"
    },
    {
        label: "Copii, Jucarii, Bebe",
        name: "bebelusi-copii-jucarii"
    },
    {
        label: "Bricolaj, Sanitare, Mobila",
        name: "casa-iluminat-bricolaj"
    },
    {
        label: "Anvelope, Electronica Auto",
        name: "auto-moto-anvelope"
    },
    {
        label: "Trotinete, Biciclete, Sport, Voiaj",
        name: "trotinete-biciclete-sport"
    }, 
];
var SubscribeForm = function(param1) {
    var user = param1.user, baseUrl = param1.baseUrl, formId = param1.formId;
    var ref3 = (0,react.useState)(false), sent = ref3[0], setSent = ref3[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(""), currentCountry = ref2[0], setCurrentCountry = ref2[1];
    var isInitial = user.isInitial, customer = user.customer;
    var handleContactSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
            var ref, status, originalError;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,api/* leadCollectorApi */.jI4)(values);
                    case 2:
                        ref = _ctx.sent;
                        status = ref.status;
                        originalError = ref.originalError;
                        if (status === 200) setSent(true);
                        else setError(originalError);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleContactSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-start justify-start w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                onSubmit: function(values) {
                    return handleContactSubmit(values);
                },
                initialValues: {
                    //! That double render will return `undefined undefined` just into the
                    //! first field `name` of this object if using the ternary conditional on it
                    //! Until the validation reaches the `phone` key the second render already
                    //! with the correct user information. THAT DOUBLE RENDER IS NOT NORMAL!
                    fc_target: formId,
                    name: "".concat((customer === null || customer === void 0 ? void 0 : customer.first_name) || "", " ").concat((customer === null || customer === void 0 ? void 0 : customer.last_name) || ""),
                    phone: !isInitial ? customer === null || customer === void 0 ? void 0 : customer.telephone : "",
                    email: !isInitial ? customer === null || customer === void 0 ? void 0 : customer.email : ""
                },
                render: function(param) {
                    var handleSubmit = param.handleSubmit, submitting = param.submitting, pristine = param.pristine, invalid = param.invalid;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                        className: "flex flex-col space-y-5 w-full",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    className: "!w-full md:!w-5/6 !max-w-full",
                                    name: "company",
                                    label: "Numele companiei",
                                    type: "text",
                                    component: InputText/* default */.Z,
                                    required: true,
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxLength */.aG)(60))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                        className: "!w-full md:!w-5/6 !max-w-full",
                                        name: "country",
                                        label: "Tara",
                                        type: "select",
                                        component: Select/* default */.Z,
                                        required: true,
                                        validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                                        children: countries.map(function(country, key) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                value: country,
                                                children: country
                                            }, key);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_listeners_es/* OnChange */.GU, {
                                        name: "country",
                                        children: function(value) {
                                            setCurrentCountry(value);
                                        }
                                    })
                                ]
                            }),
                            currentCountry === "Romania" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    className: "!w-full md:!w-5/6 !max-w-full",
                                    name: "commercial_register_number",
                                    label: "Numar Registrul Comertului",
                                    type: "text",
                                    component: InputText/* default */.Z,
                                    required: true,
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)())
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    className: "!w-full md:!w-5/6 !max-w-full",
                                    name: "name",
                                    label: "Persoana de contact",
                                    type: "text",
                                    component: InputText/* default */.Z,
                                    required: true,
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(3), (0,validations/* hasMaxLength */.aG)(100))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    className: "!w-full md:!w-5/6 !max-w-full",
                                    name: "phone",
                                    label: "Numar de telefon",
                                    type: "tel",
                                    component: InputText/* default */.Z,
                                    required: true,
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)())
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    className: "!w-full md:!w-5/6 !max-w-full",
                                    name: "email",
                                    label: "Adresa de email",
                                    type: "email",
                                    component: InputText/* default */.Z,
                                    required: true,
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isEmail */.Jh)())
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    className: "!w-full md:!w-5/6 !max-w-full",
                                    name: "website",
                                    label: "Website",
                                    type: "text",
                                    component: InputText/* default */.Z,
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isURL */.PX)(), (0,validations/* hasMaxLength */.aG)(80))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full md:w-5/6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxList, {
                                    items: categories,
                                    title: "Vreau sa vand produse in categoria",
                                    name: "category",
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col space-y-2 w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                        className: "!w-full md:!w-5/6 text-sm !max-w-full",
                                        name: "terms_and_services",
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block font-medium",
                                                    children: "Accept"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(baseUrl, "/suport-clienti/informatii-generale-termeni-si-conditii/"),
                                                    title: "Termenii si Conditiile",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "font-bold text-red-lightdark",
                                                    children: "Termenii si conditiile Altex Marketplace"
                                                })
                                            ]
                                        }),
                                        type: "checkbox",
                                        component: Checkbox/* default */.Z,
                                        required: true,
                                        validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)())
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                        className: "!w-full md:!w-5/6 text-sm !max-w-full",
                                        name: "gdpr",
                                        label: "Accept politica GDPR",
                                        type: "checkbox",
                                        component: Checkbox/* default */.Z,
                                        required: true,
                                        validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)())
                                    })
                                ]
                            }),
                            sent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between w-full md:w-5/6 px-3.5 py-3 rounded-tr-lg rounded-bl-lg ".concat(error ? "bg-alertRed-bg/25" : "bg-[#62D040]/25"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm font-medium ".concat(error ? "text-alertRed" : "text-[#319D10]"),
                                        children: error ? "Cererea nu a putut fi inregistrata. Incercati din nou." : "Cererea a fost inregistrata cu succes!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center justify-center rounded-full w-4 h-4 ".concat(error ? "bg-alertRed" : "bg-[#319D10]", " cursor-pointer"),
                                        onClick: function() {
                                            return setSent(false);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            className: "w-2 h-2",
                                            version: "1.1",
                                            viewBox: "0 0 512 512",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                fill: "#FFFFFF",
                                                points: "512,59.076 452.922,0 256,196.922 59.076,0 0,59.076 196.922,256 0,452.922 59.076,512 256,315.076 452.922,512 512,452.922 315.076,256"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full md:w-44",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    title: "Inscrie-te acum",
                                    type: "submit",
                                    display: "block",
                                    isOrderAgain: true,
                                    disabled: submitting || pristine || invalid,
                                    variant: "secondary",
                                    hasMinWidth: false
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[14px] mb-[4px] mt-[25px]",
                children: "Ai deja cont? Logheaza-te in platforma aici!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full md:w-44",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: "Logheaza-te in cont",
                    display: "block",
                    isOrderAgain: true,
                    variant: "secondary",
                    hasMinWidth: true,
                    href: "https://marketplace.altex.ro/admin"
                })
            })
        ]
    }));
};
/* harmony default export */ var Marketplace_SubscribeForm = (SubscribeForm);

// EXTERNAL MODULE: ./components/Form/Textarea.js
var Textarea = __webpack_require__(4792);
;// CONCATENATED MODULE: ./components/Marketplace/ContactForm.js









function ContactForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ContactForm_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ContactForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ContactForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ContactForm = function(param1) {
    var user = param1.user, formId = param1.formId;
    var ref2 = (0,react.useState)(false), sent = ref2[0], setSent = ref2[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var isInitial = user.isInitial, customer = user.customer;
    var handleContactSubmit = function() {
        var _ref = ContactForm_asyncToGenerator(runtime_default().mark(function _callee(values) {
            var ref, status, originalError;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,api/* leadCollectorApi */.jI4)(values);
                    case 2:
                        ref = _ctx.sent;
                        status = ref.status;
                        originalError = ref.originalError;
                        if (status === 200) setSent(true);
                        else setError(originalError);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleContactSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-start justify-start w-full space-y-4 md:pl-32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
            onSubmit: function(values) {
                return handleContactSubmit(values);
            },
            initialValues: {
                //! That double render will return `undefined undefined` just into the
                //! first field `name` of this object if using the ternary conditional on it
                //! Until the validation reaches the `email` key the second render already
                //! with the correct user information. THAT DOUBLE RENDER IS NOT NORMAL!
                fc_target: formId,
                name: "".concat((customer === null || customer === void 0 ? void 0 : customer.first_name) || "", " ").concat((customer === null || customer === void 0 ? void 0 : customer.last_name) || ""),
                email: !isInitial ? customer === null || customer === void 0 ? void 0 : customer.email : ""
            },
            render: function(param) {
                var handleSubmit = param.handleSubmit, submitting = param.submitting, pristine = param.pristine, invalid = param.invalid;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                    className: "flex flex-col space-y-5 w-full",
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                className: "!w-full !max-w-full",
                                name: "name",
                                label: "Nume",
                                type: "text",
                                component: InputText/* default */.Z,
                                required: true,
                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(3), (0,validations/* hasMaxLength */.aG)(100))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                className: "!w-full !max-w-full",
                                name: "email",
                                label: "Email",
                                type: "email",
                                component: InputText/* default */.Z,
                                required: true,
                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isEmail */.Jh)())
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                className: "!w-full !max-w-full",
                                name: "company",
                                label: "Nume companie",
                                type: "text",
                                component: InputText/* default */.Z,
                                required: true,
                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxLength */.aG)(60))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                className: "!w-full !max-w-full",
                                name: "subject",
                                label: "Subiect mesaj",
                                type: "text",
                                component: InputText/* default */.Z,
                                required: true,
                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(1), (0,validations/* hasMaxLength */.aG)(100))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                className: "!w-full !max-w-full",
                                name: "message",
                                label: "Mesaj",
                                type: "textarea",
                                component: Textarea/* default */.Z,
                                required: true,
                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(1), (0,validations/* hasMaxLength */.aG)(3000))
                            })
                        }),
                        sent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between w-full px-3.5 py-3 rounded-tr-lg rounded-bl-lg ".concat(error ? "bg-alertRed-bg/25" : "bg-[#62D040]/25"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm font-medium ".concat(error ? "text-alertRed" : "text-[#319D10]"),
                                    children: error ? "Cererea nu a putut fi inregistrata. Incercati din nou." : "Cererea a fost inregistrata cu succes!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center justify-center rounded-full w-4 h-4 ".concat(error ? "bg-alertRed" : "bg-[#319D10]", " cursor-pointer"),
                                    onClick: function() {
                                        return setSent(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: "w-2 h-2",
                                        version: "1.1",
                                        viewBox: "0 0 512 512",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            fill: "#FFFFFF",
                                            points: "512,59.076 452.922,0 256,196.922 59.076,0 0,59.076 196.922,256 0,452.922 59.076,512 256,315.076 452.922,512 512,452.922 315.076,256"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full md:w-44",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                title: "Trimite",
                                type: "submit",
                                display: "block",
                                isOrderAgain: true,
                                disabled: submitting || pristine || invalid,
                                variant: "secondary",
                                hasMinWidth: false
                            })
                        })
                    ]
                });
            }
        })
    }));
};
/* harmony default export */ var Marketplace_ContactForm = (ContactForm);

;// CONCATENATED MODULE: ./pages/marketplace.js









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteTitle = _publicRuntimeConfig.content.websiteTitle, _settings = _publicRuntimeConfig.settings, websiteStatics = _settings.websiteStatics, baseUrl = _settings.baseUrl, _marketplace = _settings.marketplace, mktpSubscribeId = _marketplace.mktpSubscribeId, mktpContactId = _marketplace.mktpContactId;
var cards = [
    {
        id: 0,
        title: "produse vandute anual",
        icon: "".concat(websiteStatics, "/images/marketplace/sold-products.svg"),
        count: 22,
        unit: "milioane"
    },
    {
        id: 1,
        title: "vizite unice",
        icon: "".concat(websiteStatics, "/images/marketplace/unique-visits.svg"),
        count: 45,
        unit: "milioane"
    },
    {
        id: 2,
        title: "afisari",
        icon: "".concat(websiteStatics, "/images/marketplace/views.svg"),
        count: 180,
        unit: "milioane"
    }, 
];
var Marketplace = function(param) {
    var user = param.user;
    return websiteTitle === "Altex" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Altex Marketplace - Scaleaza-ti afacerea la nivelul urmator!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Marketplace-ul Altex iti ofera o alternativa optima si eficienta de a comercializa produsele afacerii tale si de a te adresa unei noi baze de clienti din toata Romania!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "marketplace, vendor, seller, mktp"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center justify-center w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "block h-[500px] md:h-[354px] w-full object-cover object-right",
                                src: "".concat(websiteStatics, "/images/marketplace/headline-background-mobile.png"),
                                srcSet: "".concat(websiteStatics, "/images/marketplace/headline-background-mobile.png 768w, ").concat(websiteStatics, "/images/marketplace/headline-background.png 1270w"),
                                alt: "Dezvolta-ti propria afacere pe Altex Marketplace",
                                draggable: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute bottom-0 left-0 md:top-0 p-4 md:p-20 flex flex-col items-start w-full md:w-2/3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-3xl md:text-4xl xl:text-5xl text-white font-medium w-full",
                                        children: "Altex Marketplace"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "w-full max-w-sm md:max-w-full md:w-2/3 pr-10 lg:pr-14 leading-5 md:leading-7 md:text-xl xl:text-2xl text-black font-semibold md:font-medium",
                                        children: "Dezvolta-ti propria afacere pe Altex Marketplace"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-2 md:mt-4 w-full md:w-44",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            title: "Inscrie-te acum",
                                            display: "block",
                                            font: "medium",
                                            size: "small",
                                            isOrderAgain: true,
                                            variant: "secondary",
                                            hasMinWidth: false,
                                            href: "#formular-de-inscriere"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center w-full bg-[#F1F1F1]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col md:flex-row items-center justify-center w-full md:space-x-4 space-y-3 md:space-y-0 px-3 md:px-0 py-4 md:py-14 md:max-w-2xl xl:max-w-4xl",
                            children: cards.map(function(icon) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Card, _objectSpread({}, icon), icon.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col-reverse md:flex-row items-center justify-center w-full pt-12 lg:pt-16 md:max-w-2xl xl:max-w-4xl px-2 md:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-start justify-start w-full md:w-2/3 space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        id: "de-ce-sa-vinzi-pe-altex-marketplace",
                                        className: "w-full leading-7 text-xl xl:text-[28px] text-black font-semibold md:font-medium text-left",
                                        children: "De ce sa iei in calcul marketplace-ul Altex ca o noua platforma de vanzari?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "list-[disc] marker:text-yellow-text marker:text-2xl pl-5 md:pl-6 md:pr-24",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "text-sm xl:text-base leading-6 xl:leading-7",
                                                children: "Ai oportunitatea sa iti vinzi produsele pe unul dintre cele mai cunoscute canale de vanzare din Romania"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "text-sm xl:text-base leading-6 xl:leading-7",
                                                children: "Ai acces la o baza de clienti stabila, in continua crestere"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "text-sm xl:text-base leading-6 xl:leading-7",
                                                children: "Procesul de integrare este rapid si simplu"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "text-sm xl:text-base leading-6 xl:leading-7",
                                                children: "Suport personalizat pe toata durata parteneriatului, prin echipa de specialisti in ecommerce"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "text-sm xl:text-base leading-6 xl:leading-7",
                                                children: "Comision unic 8% pentru comenzile a caror valoare depaseste 100 lei"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "text-sm xl:text-base leading-6 xl:leading-7",
                                                children: "Optiunea de livrare prin curierul Altex, fara costuri pentru tine"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full md:w-44",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            title: "Inscrie-te acum",
                                            display: "block",
                                            isOrderAgain: true,
                                            variant: "secondary",
                                            hasMinWidth: false,
                                            href: "#formular-de-inscriere"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center mb-10 md:mb-0 w-full md:w-1/3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "block w-48 xl:w-60 select-none",
                                    src: "".concat(websiteStatics, "/images/marketplace/why-marketplace.svg"),
                                    alt: "De ce sa vinzi pe Altex Marketplace?"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col md:flex-row items-center justify-center w-full pt-24 md:max-w-2xl xl:max-w-4xl px-2 md:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center mb-10 md:mb-0 w-full md:w-1/3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "block w-48 xl:w-60 select-none",
                                    src: "".concat(websiteStatics, "/images/marketplace/steps-marketplace.svg"),
                                    alt: "De ce sa vinzi pe Altex Marketplace?"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-start justify-start w-full md:w-2/3 space-y-5 md:pl-28",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        id: "care-sunt-pasii-pentru-a-vinde-pe-altex-marketplace?",
                                        className: "w-full leading-7 text-xl xl:text-[28px] text-black font-semibold md:font-medium",
                                        children: "Altex, marketplace-ul din Romania care te ajuta sa-ti scalezi vanzarile - Care sunt pasii?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "list-[disc] marker:text-yellow-text marker:text-2xl pl-5 md:pl-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "text-sm xl:text-base leading-6 xl:leading-7",
                                                children: "Completeaza formularul “Inscrie-te acum”"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "text-sm xl:text-base leading-6 xl:leading-7",
                                                children: "Asteapta evaluarea specialistilor nostri si instructiuni pentru pasii urmatori"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "text-sm xl:text-base leading-6 xl:leading-7",
                                                children: "Incepe sa vinzi produsele tale pe Altex Marketplace"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                        children: "*Prioritizam companiile cu minim doi ani vechime, cu produse relevante pentru categoriile Jucarii & Bebe, Sport, Mobila, Decoratiuni, Ingrijirea Casei , Bricolaj, Auto, Produse pentru animale si Bauturi si o cifra de afaceri echivalenta a minim 300,000 EUR in ultimul an."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col md:flex-row items-center justify-center md:space-x-4 space-y-2 md:space-y-0 w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                title: "Inscrie-te acum",
                                                display: "block",
                                                isOrderAgain: true,
                                                variant: "secondary",
                                                hasMinWidth: false,
                                                href: "#formular-de-inscriere"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs font-medium",
                                                children: "sau"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                title: "Contacteaza-ne",
                                                display: "block",
                                                isOrderAgain: true,
                                                variant: "primary",
                                                hasMinWidth: false,
                                                href: "#formular-de-contact"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col-reverse md:flex-row items-center justify-center w-full pt-24 md:max-w-2xl xl:max-w-4xl px-2 md:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-start justify-start w-full md:w-2/3 space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "formular-de-inscriere",
                                        className: "w-full leading-7 text-xl xl:text-[28px] text-black font-semibold md:font-medium text-left",
                                        children: "Formular de inscriere"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketplace_SubscribeForm, {
                                        user: user,
                                        baseUrl: baseUrl,
                                        formId: mktpSubscribeId
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center mb-10 md:mb-0 w-full md:w-1/3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "block w-48 xl:w-60 select-none",
                                    src: "".concat(websiteStatics, "/images/marketplace/subscribe-form.svg"),
                                    alt: "Formular de inscriere"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col md:flex-row items-center justify-center w-full pt-24 md:max-w-2xl xl:max-w-4xl px-2 md:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center mb-10 md:mb-0 w-full md:w-1/3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "block w-48 xl:w-60 select-none",
                                    src: "".concat(websiteStatics, "/images/marketplace/contact-form.svg"),
                                    alt: "Formular de contact"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-start justify-start w-full space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "formular-de-contact",
                                        className: "w-full leading-7 text-xl xl:text-[28px] text-black font-semibold md:font-medium text-left md:pl-32",
                                        children: "Formular de contact"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketplace_ContactForm, {
                                        user: user,
                                        formId: mktpContactId
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
        layout: "404",
        children: "Ne pare rau, dar pagina cautata nu a fost gasita"
    });
};
var Card = function(param) {
    var title = param.title, icon = param.icon, count = param.count, unit = param.unit;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col self-stretch items-center justify-center w-full md:max-w-[230px] py-6 xl:py-10 bg-white rounded-lg ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "w-14 xl:w-20 !h-14 xl:!h-20 p-1 select-none",
                src: icon,
                alt: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-5xl leading-10 pt-2 md:leading-normal md:pt-0 font-medium h-1/4 mb-0 md:mb-2 xl:mb-0",
                children: count
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "h-1/5 leading-10 md:leading-normal pb-2 md:pb-0 text-xl xl:text-2xl font-medium",
                children: unit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm xl:text-base font-semibold h-1/5 text-[#ADADAD] text-center px-2.5 xl:px-6",
                children: title
            })
        ]
    });
};
Marketplace.pageLayout = "default";
/* harmony default export */ var marketplace = ((0,withRouterPageLayout/* default */.Z)((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user
    };
})(Marketplace)));


/***/ }),

/***/ 73337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GU": function() { return /* binding */ OnChange; }
/* harmony export */ });
/* unused harmony exports ExternallyChanged, OnBlur, OnFocus */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66688);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var ExternallyChangedState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ExternallyChangedState, _React$Component);

  function ExternallyChangedState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: props.input.value,
      externallyChanged: false
    };
    return _this;
  }

  var _proto = ExternallyChangedState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        value = _this$props.input.value,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (value !== previous) {
      this.setState({
        previous: value,
        externallyChanged: !active
      });
    }
  };

  _proto.render = function render() {
    return this.props.children(this.state.externallyChanged);
  };

  return ExternallyChangedState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var ExternallyChanged = function ExternallyChanged(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true,
      value: true
    },
    allowNull: true,
    render: function render(props) {
      return createElement(ExternallyChangedState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnBlurState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnBlurState, _React$Component);

  function OnBlurState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: !!props.meta.active
    };
    return _this;
  }

  var _proto = OnBlurState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (previous && !active) {
      children();
    }

    if (previous !== active) {
      this.setState({
        previous: active
      });
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnBlurState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnBlur = function OnBlur(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true
    },
    render: function render(props) {
      return createElement(OnBlurState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnChangeState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnChangeState, _React$Component);

  function OnChangeState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: props.input.value
    };
    return _this;
  }

  var _proto = OnChangeState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        value = _this$props.input.value;
    var previous = this.state.previous;

    if (value !== previous) {
      this.setState({
        previous: value
      });
      children(value, previous);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnChangeState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnChange = function OnChange(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
    name: name,
    subscription: {
      value: true
    },
    allowNull: true,
    render: function render(props) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(OnChangeState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnFocusState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnFocusState, _React$Component);

  function OnFocusState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: !!props.meta.active
    };
    return _this;
  }

  var _proto = OnFocusState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (active && !previous) {
      this.setState({
        previous: active
      });
      children();
    } else if (!active && previous) {
      this.setState({
        previous: active
      });
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnFocusState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnFocus = function OnFocus(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true
    },
    render: function render(props) {
      return createElement(OnFocusState, _extends({}, props, {
        children: children
      }));
    }
  });
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(30588); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);